import React from 'react';
import loadable from '@loadable/component';

import {
  ConstructorBlockType,
  IConstructorGridItem,
  IPossibleConstructorGridItem,
} from '@/interfaces/constructor.interfaces';

import { ConstructorItemProps } from './ConstructorItem.types';
import { getConstructorItemStyle } from './ConstructorItem.utils';

import styles from './ConstructorItem.module.scss';

const Catalog = loadable(() => import('@/blocks/constructor/Catalog'));
const CarsHeader = loadable(() => import('@/blocks/constructor/CarsHeader'));
const CarHeader = loadable(() => import('@/blocks/constructor/CarHeader'));
const Benefits = loadable(() => import('@/blocks/constructor/Benefits'));
const BenefitsFootnote = loadable(() => import('@/blocks/constructor/BenefitsFootnote'));
const Card = loadable(() => import('@/blocks/constructor/Card'));
const DealerMap = loadable(() => import('@/blocks/constructor/DealerMap'));
const DealerComment = loadable(() => import('@/blocks/constructor/DealerComment'));
const Equipments = loadable(() => import('@/blocks/constructor/Equipments'));
const EquipmentsCustom = loadable(() => import('@/blocks/constructor/EquipmentsCustom'));
const Finance = loadable(() => import('@/blocks/constructor/Finance'));
const BookingRequest = loadable(() => import('@/blocks/constructor/BookingRequest'));
const Button = loadable(() => import('@/blocks/common/Button'));
const Custom = loadable(() => import('@/blocks/common/Custom'));

const renderConstructorBlock = (item: IPossibleConstructorGridItem) => {
  const { id, type, props } = item;
  switch (type) {
    case ConstructorBlockType.CarsHeader:
      return <CarsHeader key={id} {...props} />;
    case ConstructorBlockType.Catalog:
      return <Catalog key={id} {...props} />;
    case ConstructorBlockType.CarHeader:
      return <CarHeader key={id} {...props} />;
    case ConstructorBlockType.Benefits:
      return <Benefits key={id} {...props} />;
    case ConstructorBlockType.BenefitsFootnote:
      return <BenefitsFootnote key={id} {...props} />;
    case ConstructorBlockType.CarCard:
      return <Card key={id} {...props} />;
    case ConstructorBlockType.DealerMap:
      return <DealerMap key={id} {...props} />;
    case ConstructorBlockType.DealerComment:
      return <DealerComment key={id} {...props} />;
    case ConstructorBlockType.Equipments:
      return <Equipments key={id} {...props} />;
    case ConstructorBlockType.EquipmentsCustom:
      return <EquipmentsCustom key={id} {...props} />;
    case ConstructorBlockType.Finance:
      return <Finance key={id} {...props} />;
    case ConstructorBlockType.BookingRequest:
      return <BookingRequest key={id} {...props} />;
    case ConstructorBlockType.Custom:
      return <Custom id={id} key={id} {...props} />;
    case ConstructorBlockType.Button:
      return <Button id={id} key={id} data={null} {...props} />;
    default:
      return null;
  }
};

function ConstructorItem({ item }: ConstructorItemProps) {
  const constructorBlock = renderConstructorBlock(item);

  if (!constructorBlock) {
    return null;
  }

  return (
    <section
      id={item.id}
      style={getConstructorItemStyle(item as IConstructorGridItem)}
      className={styles.constructorItem}
    >
      {constructorBlock}
    </section>
  );
}

export default ConstructorItem;
